import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import { useProductCategoriesValueContextHook } from "../../../../contexts/ProductCategoriesContext";
import styled from 'styled-components';
import { useSettingVariablesActionsContextHook, useSettingVariablesValueContextHook } from "../../../../contexts/SettingVariablesContext";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    button{
        border-radius: 3px;
        
        &.selected{
            background-color: #333;
            color:#fff;
            font-weight: 700;
        }
    }
`;

export function ModalProductCategorySelector({
    open,
    onClose
}) {
    const settingVariablesValueContextHook = useSettingVariablesValueContextHook();
    const settingVariablesActionsContextHook = useSettingVariablesActionsContextHook();
    const settingVariables = settingVariablesValueContextHook?.settingVariables;

    const productCategoriesValueContextHook = useProductCategoriesValueContextHook();

    const productCategories = productCategoriesValueContextHook?.productCategories || [];

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            상품 카테고리 선택
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    {productCategories?.map(productCategory => {
                        const isSelected = settingVariables?.productCategoryIds?.includes(productCategory?.id);
                        return (
                            <CustomBlockButton
                                key={productCategory?.id}
                                type='button'
                                className={isSelected ? 'selected' : ''}
                                onClick={() => {
                                    settingVariablesActionsContextHook?.settingVariables.setValue(prev => {
                                        const newProductCategoryIds = prev?.productCategoryIds || [];
                                        if (newProductCategoryIds.includes(productCategory?.id)) {
                                            return {
                                                ...prev,
                                                productCategoryIds: newProductCategoryIds.filter(id => id !== productCategory?.id)
                                            };
                                        }
                                        newProductCategoryIds.push(productCategory?.id);
                                        return {
                                            ...prev,
                                            productCategoryIds: newProductCategoryIds
                                        }
                                    });
                                }}
                            >
                                {productCategory?.name}
                            </CustomBlockButton>
                        );
                    })}

                </StyledBody>
                <div style={{ position: 'sticky', bottom: 0, left: 0, right: 0, padding: 10, borderTop: '1px solid #efefef', backgroundColor: '#fff', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <CustomBlockButton
                        type='button'
                        style={{ width: '100px', borderRadius: '3px', backgroundColor: '#efefef', border: '1px solid #00000000', color: '#333', fontWeight: 700 }}
                        onClick={() => {
                            settingVariablesActionsContextHook?.settingVariables.setValue(prev => ({
                                ...prev,
                                productCategoryIds: []
                            }));
                        }}
                    >
                        CLEAR
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        style={{ width: '100px', borderRadius: '3px', border: '1px solid #333', color: '#333', fontWeight: 700 }}
                        onClick={() => { onClose() }}
                    >
                        선택완료
                    </CustomBlockButton>
                </div>
            </CustomDialog>
        </>
    );
}